import { Routes, Route } from "react-router";
import ActivityLogsMain from "Modules/activities/views/main";
import { HasPermission } from "Core/security";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
const RouterUserActivityLogs = (props) => {
    const user = useSelector(state => state.securityRedux.user);
    return (
        <>
            <Routes>
                {HasPermission(user, "act") && <Route path="list" element={<ActivityLogsMain />} />}
                <Route path="*" element={<Navigate to="/error" />} />
            </Routes>
        </>
    )
}
export default RouterUserActivityLogs;